import { store } from "../store/GameStore.js";
import { el } from "./dom.js";

const DURATION_MS = 3200;

export class Toasts {
  private readonly root: HTMLElement;

  constructor(parent: HTMLElement) {
    this.root = el("div", "toasts");
    parent.appendChild(this.root);
  }

  push(text: string, tone: "info" | "error" | "success" = "info"): void {
    const toast = el("div", `toast ${tone}`, text);
    this.root.appendChild(toast);
    setTimeout(() => toast.remove(), DURATION_MS);
  }

  mount(): void {
    store.on("rejected", (msg) => this.push(msg.message || "Not possible.", "error"));
    store.on("connection", (c) => {
      if (c.state === "reconnecting") this.push("Reconnecting…", "info");
      if (c.state === "closed") {
        this.push(
          c.code === 4002 ? "You joined from another tab." : "Disconnected from the office.",
          "error",
        );
      }
    });
    store.on("playerEvent", (event) => {
      if (event.sessionId !== store.sessionId) return;
      if (event.event === "burnout") this.push("You burned out — grab a coffee ☕", "error");
      if (event.event === "coffee_done") this.push("Fully rested ☕", "success");
      if (event.event === "rested") this.push("Rested and ready.", "success");
    });
    store.on("projectStarted", (p) => this.push(`New project: ${p.projectName}`, "success"));
  }
}
